import Stack from '@mui/material/Stack';

import { ensureDefined } from '@e-socna/utils';

import { Loading } from '../../../../components/Loading';
import { NoData } from '../../../../components/Illustrations/NoData';
import { useFindAllMaterialsQuery } from '../../../../components/MaterialList/hooks/useFindAllMaterialsQuery.hook';
import { useContextualizedFields } from '../../../../hooks/useContextualizedFields.hook';

import type { MaterialUsageForm_MaterialUsage } from '../../fragments/material-usage.fragment';

import { Item } from './Item';

interface Props {
  readonly formContext?: string;
  readonly id: string;
}

export const MaterialsUsageFormStep = ({ formContext }: Readonly<Props>) => {
  const { data, isSuccess } = useFindAllMaterialsQuery();

  const fields = useContextualizedFields<
    Readonly<{
      materialUsages: readonly MaterialUsageForm_MaterialUsage[] | undefined;
    }>
  >(
    {
      materialUsages: {
        id: 'material-usages',
        name: 'materialUsages',
      },
    },
    formContext,
  );

  const { materialUsages } = ensureDefined({
    materialUsages: fields.materialUsages.value,
  });

  if (!materialUsages.length) {
    return <NoData />;
  }

  if (!isSuccess) {
    return <Loading />;
  }

  const allMaterials = data.findAllMaterials;

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {materialUsages.map((materialUsage, index) => (
        <Item
          allMaterials={allMaterials}
          formContext={formContext}
          index={index}
          key={materialUsage._id}
          materialUsage={materialUsage}
        />
      ))}
    </Stack>
  );
};
